// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2Mmkk","unreadBadge":"styles_unreadBadge__1OTmr","modalContent":"styles_modalContent__2BlnC","modal":"styles_modal__12mWv"};